"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1UserSeriesDetailsGet = void 0;
exports.v1UserSeriesDetailsGetSetMock = v1UserSeriesDetailsGetSetMock;
exports.v1UserSeriesDetailsGet = v1UserSeriesDetailsGet;
exports.useQueryV1UserSeriesDetailsGet = useQueryV1UserSeriesDetailsGet;
exports.useInfiniteQueryV1UserSeriesDetailsGet = useInfiniteQueryV1UserSeriesDetailsGet;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1UserSeriesDetailsGetSetMock(mock) {
    setMock = mock;
}
async function v1UserSeriesDetailsGet(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/user-series-details`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.softwareNumber = params.softwareNumber;
    queryParams.seriesIds = params.seriesIds;
    queryParams.isClub = params.isClub;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1UserSeriesDetailsGet = 'wolf-dashboard-service:v1UserSeriesDetailsGet:get';
function useQueryV1UserSeriesDetailsGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1UserSeriesDetailsGet, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1UserSeriesDetailsGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1UserSeriesDetailsGet, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1UserSeriesDetailsGet(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-user-series-details-get.js.map